import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-document-card',
  imports: [MatButtonModule, MatIconModule],
  template: `
    <div class="document-card">
      <div class="document-header">
        <mat-icon>picture_as_pdf</mat-icon>
        <h3>{{ title() }}</h3>
      </div>
      <div class="document-content">
        <div class="document-details">
          <span class="file-name">{{ fileName() }}</span>
          <div class="document-meta">
            <span>{{ metaInfo() }}</span>
            <span class="file-size">{{ fileSize() }}</span>
          </div>
        </div>
        <div class="document-actions">
          <button mat-raised-button (click)="downloadClicked.emit()">
            <mat-icon>download</mat-icon>
            Herunterladen
          </button>
          @if (showManageActions()) {
            <button mat-button (click)="replaceClicked.emit()">
              <mat-icon>sync</mat-icon>
              Ersetzen
            </button>
            <button mat-button class="delete-button" (click)="deleteClicked.emit()">
              <mat-icon>delete</mat-icon>
              Löschen
            </button>
          }
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .document-card {
        background: white;
        border-radius: var(--border-radius);
        box-shadow: 0 2px 8px var(--dashboard-stats-shadow);
        overflow: hidden;
      }

      .document-header {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 1rem 1.5rem;
        border-bottom: 1px solid var(--theme-border);
        background-color: #f8f9fa;

        mat-icon {
          color: var(--theme-primary);
        }

        h3 {
          margin: 0;
          font-size: 1.125rem;
          font-weight: 500;
          color: var(--dashboard-stats-text-primary);
        }
      }

      .document-content {
        padding: 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      .document-details {
        .file-name {
          font-weight: 500;
          display: block;
          margin-bottom: 0.5rem;
        }

        .document-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          color: var(--dashboard-stats-text-secondary);
          font-size: 0.875rem;

          @media (max-width: 768px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.25rem;
          }
        }

        .file-size {
          font-weight: 500;
          flex-shrink: 0;
        }
      }

      .document-actions {
        display: flex;
        gap: 0.5rem;
        justify-content: center;
        padding-top: 0.5rem;
        border-top: 1px solid var(--theme-border);

        @media (max-width: 768px) {
          flex-direction: column;
        }
      }

      .delete-button {
        --mdc-text-button-label-text-color: var(--mat-sys-error);
      }
    `,
  ],
})
export class DocumentCardComponent {
  title = input('');
  fileName = input('');
  metaInfo = input('');
  fileSize = input('');
  showManageActions = input(false);

  downloadClicked = output<void>();
  replaceClicked = output<void>();
  deleteClicked = output<void>();
}
